// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my-regions_3f0qW.disabled__-2Q3 input:hover{cursor:not-allowed!important}.my-regions_3f0qW.disabled__-2Q3 input div,.my-regions_3f0qW.disabled__-2Q3 input label{color:#272525!important}::v-deep :not(.v-icon_1l8zG){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_215O5 .flexContainer_3PiG8{display:flex;align-content:space-between}.nsAddressForm_215O5 .flexContainer_3PiG8 .firstCol_1Rbqz{margin-right:20px}.nsAddressForm_215O5 .flexContainer_3PiG8 .region_F2xm2{width:70px}.optional_2L4FZ{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"my-regions": "my-regions_3f0qW",
	"disabled": "disabled__-2Q3",
	"v-icon": "v-icon_1l8zG",
	"nsAddressForm": "nsAddressForm_215O5",
	"flexContainer": "flexContainer_3PiG8",
	"firstCol": "firstCol_1Rbqz",
	"region": "region_F2xm2",
	"optional": "optional_2L4FZ"
};
module.exports = exports;
